import { Typography } from '@project44/manifest-ds';

import { EntityEnum } from '../../definitions/enums/Entity';
import { BlockNumberType } from '../../definitions/types/BlockNumber';
import { BlockNumber } from '../BlockNumber';

import { BodyTitle, EntityLabel, EntityLabelSkeleton } from './styles';

interface EntityTitleProps {
  entityType: EntityEnum;
  workspacePosition?: BlockNumberType;
  title?: string;
  type?: string;
}

export const EntityTitle = ({
  workspacePosition,
  entityType,
  title,
  type,
}: EntityTitleProps) => {
  return (
    <BodyTitle>
      <BlockNumber
        entityType={entityType}
        number={workspacePosition}
        type="filled"
        size={24}
      />
      {title ? (
        <Typography variant="heading" data-testid="entity-type-title">
          {title}
        </Typography>
      ) : (
        <EntityLabelSkeleton />
      )}
      {type ? (
        <EntityLabel data-testid="entity-type-label">{type}</EntityLabel>
      ) : null}
    </BodyTitle>
  );
};
